
export class Contact {
    constructor(id, name, contactTypeId, value) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.ContactTypeId = contactTypeId;
    }

}